module.exports = __webpack_public_path__ + "img/微信.238f133e.png";